import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import { IRouteProps } from 'IRoute'

import sidebarMenu from 'commons/constants/sidebarMenu'
import { useAuth } from 'hooks/auth'
import { useFeatureFlags } from 'hooks/featureFlags'
import { useRoles } from 'hooks/roles'
import { useUser } from 'hooks/user'
import NoPermission from 'pages/NoPermission'

const PrivateRoute: React.FC<IRouteProps> = ({ roles, ...rest }) => {
  const { isAuthenticated } = useAuth()
  const { hasRoles } = useRoles()
  const { hasFeatureFlag } = useFeatureFlags()
  const { user } = useUser()

  if (!isAuthenticated()) {
    return <Redirect to="/login" />
  }

  if (!hasRoles(roles)) {
    // Check if user has no permissions at all
    if (!user?.roles || user.roles.length === 0) {
      return <NoPermission />
    }

    const userRole = user.roles[0]
    const allowedScreen = sidebarMenu.find((item) => {
      const roleAllowed = item.roles.includes(userRole) || item.roles.length === 0
      const hasRequiredFeatureFlags = item.featureFlags.length === 0 ||
        item.featureFlags.some(flag => hasFeatureFlag(flag))
      return roleAllowed && hasRequiredFeatureFlags
    })

    if (allowedScreen) {
      return <Redirect to={allowedScreen.url} />
    }

    return <NoPermission />
  }

  return <Route {...rest} />
}

export default PrivateRoute
